export default {
    transactions_result_title: 'Transactions - Results',
    transactions_result_created: 'Created',
    transactions_result_transaction: 'Transaction Id',
    transactions_result_status: 'Status',
    transactions_result_type: 'Type',
    transactions_result_message: ' Error Message',
    transactions_result_data: 'Data',
    transactions_result_created_by: 'Created By',
    transactions_result_duplicated_device: "Duplicated Device",
    transactions_result_success: "Success",
    transactions_result_failure: "Failure",
    transactions_result_pending: "Pending",
    transactions_result_show_data: 'Show Data',
};
